export const reduxKey = '@@compliantLocalStorage';
export var CompliantLocalStorageKeys;
(function(CompliantLocalStorageKeys) {
    CompliantLocalStorageKeys["RECENT_COLORS"] = "custombox.recent.colors";
    CompliantLocalStorageKeys["INTENTS"] = "intents";
    CompliantLocalStorageKeys["INTENTS_OTHER"] = "intents_other";
    CompliantLocalStorageKeys["STATUS_SUBMIT_COUNTER"] = "statusUpdateSubmitCounter";
    CompliantLocalStorageKeys["CHATDB"] = "chatDB";
    CompliantLocalStorageKeys["EDITOR_DRAFTS"] = "editorDrafts";
    CompliantLocalStorageKeys["NC_DELETE_ON_REPLY"] = "ncDeleteOnReply";
    CompliantLocalStorageKeys["DO_NOT_SHOW_AGAIN"] = "confirm.modal.do.not.show";
    CompliantLocalStorageKeys["SOCIAL"] = "social";
    CompliantLocalStorageKeys["DREAMUP_ANON_FORM"] = "dreamup_anon_form";
})(CompliantLocalStorageKeys || (CompliantLocalStorageKeys = {}));
export var CompliantCategories;
(function(CompliantCategories) {
    CompliantCategories["ESSENTIAL"] = "essential";
    CompliantCategories["FUNCTIONAL"] = "functional";
})(CompliantCategories || (CompliantCategories = {}));
export const LocalStorageCategoryTypeConfig = {
    ["intents"]: "essential",
    ["intents_other"]: "essential",
    ["chatDB"]: "essential",
    ["confirm.modal.do.not.show"]: "essential",
    ["social"]: "essential",
    ["custombox.recent.colors"]: "functional",
    ["statusUpdateSubmitCounter"]: "functional",
    ["editorDrafts"]: "functional",
    ["ncDeleteOnReply"]: "functional"
};
